export default {
    SUBSCRIBED_USER_MGMT_REQUEST: 'APP/SUBSCRIBED_USER_MGMT/SUBSCRIBED_USER_MGMT_REQUEST',
    SUBSCRIBED_USER_MGMT_SUCCESS: 'APP/SUBSCRIBED_USER_MGMT/SUBSCRIBED_USER_MGMT_SUCCESS',
    SUBSCRIBED_USER_MGMT_ERROR: 'APP/SUBSCRIBED_USER_MGMT/SUBSCRIBED_USER_MGMT_ERROR',
  };